<ion-content>
    <ion-buttons class="ion-float-right">
      <ion-button (click)="onCancel()">
        <ion-icon name="close" mode="md"></ion-icon>
      </ion-button>
    </ion-buttons>
  

<div class="consent-modal">

  <ng-container *ngIf="provider">
    
    <form class="consent-modal__form form" #codeF (ngSubmit)="onSave( submitBtn )">

      <div  class="ion-padding">
      <h1 class="consent-modal__form-title">{{ 'CONSENT.TITLE' | translate  }}</h1>

      <p class="consent-modal__form-desc">{{ 'CONSENT.DESCRIPTION' | translate: { company : provider.companyName }  }}</p>

      <ion-list>

        <ion-item class="ion-no-padding top-aligned-toggle">
          <ion-toggle color="primary" [(ngModel)]="providerPromotionToggle" name="providerPromotionToggle" disabled="false"></ion-toggle>

          <ion-label class="multi-line-label"><b>{{ 'CONSENT.TOGGLE_TITLE' | translate: { brand : provider.brandName } }}</b> {{ 'CONSENT.TOGGLE_DESCRIPTION' | translate }}</ion-label>

        </ion-item>

        <!--ion-item class="ion-no-padding" mode="md">
          <ion-label position="stacked" mode="md" class="consent-modal__form-label">{{ 'CONSENT.SMS_CONFIRMATION_CODE' | translate }}</ion-label>
          <ion-input class="consent-modal__form-input" name="code" [(ngModel)]="code" type="text" id="code" placeholder="{{ 'CONSENT.SMS_CONFIRMATION_CODE_NAMESPACE' | translate }}"></ion-input>

        </ion-item-->

       </ion-list>

      <ion-button style="font-size: 13px" class="btn--large" type="submit" expand="full">{{ 'CONSENT.BTN_SAVE' | translate }}</ion-button>
      <p class="ion-text-center register-prompt">{{ 'CONSENT.TIP' | translate }}</p>

      </div>

    </form>   

  </ng-container>

</div>


</ion-content>

